// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultipleForm_container__qxcgo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.MultipleForm_form-container__jEWHS {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 85vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.MultipleForm_right-button__7vIce {
  margin: auto 0 auto auto;
}

.MultipleForm_buttons-container__G-6\\+V {
  display: flex;
  margin: auto auto 0;
  flex-direction: row;
  margin-top: 20px;
  width: 100%;
}

.MultipleForm_back-button__wgLqd Button {
  padding: 11px;
}
.MultipleForm_back-button__wgLqd .MultipleForm_back-icon__H-m1S {
  font-size: 16px;
}

.MultipleForm_form-description__wRMwr {
  color: #808080;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/MultipleForms/MultipleForm.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,wBAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,oCAAA;EACA,4CAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAFF;;AAME;EACE,aAAA;AAHJ;AAME;EACE,eC7CK;ADyCT;;AAQA;EACE,cEtCoB;EFuCpB,iBC9CK;ADyCP","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.form-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 85vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\n.right-button {\n  margin: auto 0 auto auto;\n}\n\n.buttons-container {\n  display: flex;\n  margin: auto auto 0;\n  flex-direction: row;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.back-button {\n  Button {\n    padding: 11px;\n  }\n\n  .back-icon {\n    font-size: typography.$body-l;\n  }\n}\n\n.form-description {\n  color: colors.$color-text-disabled;\n  font-weight: typography.$bold;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MultipleForm_container__qxcgo`,
	"form-container": `MultipleForm_form-container__jEWHS`,
	"right-button": `MultipleForm_right-button__7vIce`,
	"buttons-container": `MultipleForm_buttons-container__G-6+V`,
	"back-button": `MultipleForm_back-button__wgLqd`,
	"back-icon": `MultipleForm_back-icon__H-m1S`,
	"form-description": `MultipleForm_form-description__wRMwr`
};
export default ___CSS_LOADER_EXPORT___;
